import { useGetCompanyImage } from "@apis/headerBanner";
import { PriceModes } from "@components/molecules/PriceModeCard/types";
import Routes from "@navigations/Routes";
import { useNavigationState } from "@react-navigation/native";
import { useSelector } from "react-redux";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { getActiveRouteName } from "@utils/analytics";
import { useState, useEffect } from "react";

export const useBannerData = () => {
  const { getPriceMode } = useUserInfo();
  const [currentIndex, setCurrentIndex] = useState(0);
  const { data } = useGetCompanyImage("banner");
  const productType = useSelector(
    (state: any) => state.appState?.activeProduct
  );
  const newRouteName = useNavigationState((state) => getActiveRouteName(state));
  const homeAdsRoutes: string[] = [
    Routes.HomeScreen,
    Routes.PagesScreen,
    Routes.HomeNavigator,
    Routes.PagesNavigator,
    Routes.AppNavigator,
    Routes.FavoritesNavigator,
    Routes.FavoritesListScreen,
    Routes.RequestHistoryNavigator,
    Routes.SavedSearch,
    Routes.Explore,
    Routes.AccountOverviewScreen,
  ];

  const getHeaderBanner = () => {
    if (!data?.data) return [];
    const bannerData = data?.data;

    if (homeAdsRoutes.includes(newRouteName)) {
      return bannerData?.response?.home || [];
    }

    if (productType && bannerData?.response?.[productType]) {
      return bannerData?.response?.[productType] || [];
    }

    return [];
  };

  const banners = getHeaderBanner();

  useEffect(() => {
    setCurrentIndex(0);
  }, [banners?.[0]?.media_url_url]);

  useEffect(() => {
    if (banners.length > 1 && getPriceMode() === PriceModes.WHITE) {
      const intervalId = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex === banners.length - 1 ? 0 : prevIndex + 1
        );
      }, 5000);

      return () => clearInterval(intervalId);
    }
  }, [banners]);

  return {
    currentBanner: banners?.[currentIndex] ?? {},
    banners,
  };
};
